import { createI18n } from 'vue-i18n';

const messages = {
  en: () => import('./locales/en-US.json').then((m) => m.default),
  es: () => import('./locales/es-MX.json').then((m) => m.default)
};

const i18n = createI18n({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'en',
  messages: {
    en: {},
    es: {}
  }
});

Promise.all([messages.en(), messages.es()]).then(([enMessages, esMessages]) => {
  i18n.global.setLocaleMessage('en', enMessages);
  i18n.global.setLocaleMessage('es', esMessages);
});

export default i18n;
